import { DefaultTheme } from 'styled-components';
import { light as lightButton } from '../components/Button/theme';
import base from './base';
import { lightColors } from './colors';

const lightTheme: DefaultTheme = {
  ...base,
  isDark: false,
  colors: lightColors,
  button: lightButton
};

export default lightTheme;
